(function() { window.GUID_c780a127_cb2a_4ed0_b71d_89b2228f3e6f = { getGuid: function() { return "c780a127-cb2a-4ed0-b71d-89b2228f3e6f"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PopupVariant;
        (function (PopupVariant) {
            PopupVariant[PopupVariant["Default"] = 0] = "Default";
            PopupVariant[PopupVariant["Drawer"] = 1] = "Drawer";
            PopupVariant[PopupVariant["SideDrawer"] = 2] = "SideDrawer";
        })(PopupVariant = Enumeration.PopupVariant || (Enumeration.PopupVariant = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PopupVariant.pre.js.map
